import { render, staticRenderFns } from "./DevicesPage.vue?vue&type=template&id=13958dc6&"
import script from "./DevicesPage.vue?vue&type=script&lang=js&"
export * from "./DevicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13958dc6')) {
      api.createRecord('13958dc6', component.options)
    } else {
      api.reload('13958dc6', component.options)
    }
    module.hot.accept("./DevicesPage.vue?vue&type=template&id=13958dc6&", function () {
      api.rerender('13958dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/DevicesPage.vue"
export default component.exports